import React, { useState } from "react"
import styled from 'styled-components';
import { CgEditBlackPoint } from "@react-icons/all-files/cg/CgEditBlackPoint";
import { Container } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import { useConfig } from "../../../hooks/use-config"
import * as Constants from "../../../helpers/constants"
import Calendly from "../../../components/calendly"

const StyledContainer = styled(Container)`

.head{
      text-align: left;
}

.cta-top{
    display:flex;
    
}

.bookdemo{
    margin-left:40px;
}


.top-main {
  margin: auto;
  text-align: center;
  background-color: #ffa90033;
  border-radius: 10px;
  padding: 10px;
}

.main {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  gap: 15px;
}

.main h1 {
  font-weight: 700 !important;
}

.lists {
  display: flex;
  padding: 0;
  gap: 17px;
  flex-wrap: wrap;
  justify-content: center;
  vertical-align: middle; 
  font-weight: 500;
  line-height: normal;
  list-style-type: none; 
}

.map {
  color: #ffa700;
}

.free-credit-btn:hover {
  background-color: #ffb426;
  border-color: #ffb426;
}

@media only screen and (max-width: 768px){
    .lists{
        display:block;
        text-align:initial;
    }
    
    .cta-top{
        display:block;
    }

    .head{
        width:100%;
        text-align: center;
    }

    .btn-cta{
        margin: 0 auto;
        text-align:center;
        gap:12px;
    }

    .bookdemo{
        margin-left:0px;
        margin-top:12px;
    }
}
`

const CreateAAccount = () => {
    const { clearout: clearoutConfig } = useConfig()
    const [showCalendly, setShowCalendly] = useState(false)

    function onClickShowCalendlyModal(e) {
        e.preventDefault()
        setShowCalendly(true)
    }

    function onCloseCalendlyModal() {
        setShowCalendly(false)
    }

    return (
        <StyledContainer>
            <div className="top-main">
                <div className="main pt-2">
                    <div className="cta-top py-2">
                        <div className="col-6 head text-center"><h2 className="fw-bolder">Start with Clearout for Best Accuracy and ROI</h2>
                        </div>
                        <div className="col-6 py-2 btn-cta">
                            <a href={clearoutConfig.app.registerUrl} target="_blank" rel="noreferrer">
                                <Button variant="secondary" className="free-credit-btn fw-bold p-2 px-4">Create a Free Account</Button>
                            </a>
                            <Button variant="secondary" onClick={onClickShowCalendlyModal} className="free-credit-btn fw-bold p-2 px-4 bookdemo">Book Demo</Button>
                            <Calendly
                                show={showCalendly}
                                eventUrl={Constants.CALENDLY_URLS.BOOK_A_DEMO}
                                onCloseHandler={onCloseCalendlyModal}
                            />
                        </div>

                    </div>

                    <ul className="lists">
                        <li><CgEditBlackPoint className="map" />Credits Never Expire</li>
                        <li><CgEditBlackPoint className="map" />24/7 Support With Expert Marketers</li>
                        <li><CgEditBlackPoint className="map" />Fully GDPR Compliant</li>
                        <li><CgEditBlackPoint className="map" />ISO & SOC 2 TYPE 2 Certified</li>
                    </ul>
                </div>
            </div>
        </StyledContainer>
    )
}

export default CreateAAccount;